import { convertWidth } from './convertWidth';
export function convertWidthToHz(peaks, options) {
    return convertWidth(peaks, { ...options, convertTo: 'hz' });
}
//# sourceMappingURL=convertWidthToHz.js.map